export enum RoleCode {
  FA_USER = 'FA_USER',
  FA_USER_COP = 'FA_USER_COP',
  FA_MANAGER = 'FA_MANAGER',
}
